import React, { useEffect, useState } from "react";
import api from "api/axios"; // ✅ Instance centralisée
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import { Card, CircularProgress, Grid, Typography } from "@mui/material";
import DataTable from "examples/Tables/DataTable";

const BudgetVsActuals = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await api.get("/quickbooks/budget-vs-actuals/");
        setReportData(response.data.report);
      } catch (error) {
        console.error("Erreur lors du chargement du rapport:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, []);

  const parseRows = () => {
    if (!reportData || !reportData.Rows) return [];

    const rows = reportData.Rows.Row || [];
    return rows
      .filter((row) => row.Rows && row.Summary !== true)
      .map((row) => {
        const cells = row.Rows.Row[0]?.ColData || [];
        return {
          account: cells[0]?.value || "",
          jan: cells[1]?.value || "",
          feb: cells[2]?.value || "",
          mar: cells[3]?.value || "",
          apr: cells[4]?.value || "",
          may: cells[5]?.value || "",
          jun: cells[6]?.value || "",
          jul: cells[7]?.value || "",
          aug: cells[8]?.value || "",
          sep: cells[9]?.value || "",
          oct: cells[10]?.value || "",
          nov: cells[11]?.value || "",
          dec: cells[12]?.value || "",
          total: cells[13]?.value || "",
        };
      });
  };

  const columns = [
    { Header: "Account", accessor: "account", align: "left" },
    { Header: "Jan", accessor: "jan", align: "right" },
    { Header: "Feb", accessor: "feb", align: "right" },
    { Header: "Mar", accessor: "mar", align: "right" },
    { Header: "Apr", accessor: "apr", align: "right" },
    { Header: "May", accessor: "may", align: "right" },
    { Header: "Jun", accessor: "jun", align: "right" },
    { Header: "Jul", accessor: "jul", align: "right" },
    { Header: "Aug", accessor: "aug", align: "right" },
    { Header: "Sep", accessor: "sep", align: "right" },
    { Header: "Oct", accessor: "oct", align: "right" },
    { Header: "Nov", accessor: "nov", align: "right" },
    { Header: "Dec", accessor: "dec", align: "right" },
    { Header: "Total", accessor: "total", align: "right" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3}>
                <Typography variant="h6" fontWeight="bold">
                  Budget vs Actuals Report
                </Typography>
              </MDBox>
              <MDBox px={3} pb={3}>
                {loading ? (
                  <CircularProgress />
                ) : (
                  <DataTable
                    table={{ columns, rows: parseRows() }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default BudgetVsActuals;
